var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightWifiSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0nj0mmonia)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.808 10.65a19.225 19.225 0 0 1 6.12 5.708v.004a1 1 0 1 1-1.646 1.136A17.224 17.224 0 0 0 7.89 15.044a17.994 17.994 0 0 0-2.014 2.446 1 1 0 0 1-1.642-1.14 19.998 19.998 0 0 1 2.242-2.72 19.224 19.224 0 0 1 23.332-2.98zm-11.872 9.846a8.06 8.06 0 0 0-3.57 2.076 8 8 0 0 0-1.68 2.488 1 1 0 1 0 1.832.8 5.998 5.998 0 0 1 3.356-3.24 6.06 6.06 0 0 1 2.468-.404c.509-.649 1.084-1.234 1.724-1.756a8.06 8.06 0 0 0-4.13.036zm11.672-2.478a12.894 12.894 0 0 0-17.139-1.743 12.9 12.9 0 0 0-3.907 4.593 1 1 0 0 0 1.784.902 10.9 10.9 0 0 1 16.55-3.57c.893-.17 1.804-.231 2.712-.182z",
    fill: "url(#v5tajhurlb)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.376 24.224a3.265 3.265 0 0 1-.289 2.405c-.199.36-.464.676-.781.927a2.927 2.927 0 0 1-1.063.537l-.688.185c-.05.527-.044 1.06.015 1.586l.522.13c.395.098.767.28 1.093.533.326.254.599.575.802.943a3.266 3.266 0 0 1 .275 2.457l-.189.66a6.5 6.5 0 0 0 1.245.81l.484-.538c.28-.31.616-.556.989-.724a2.867 2.867 0 0 1 2.362 0c.373.17.709.416.987.726l.503.559c.437-.211.846-.47 1.225-.778l-.234-.868a3.267 3.267 0 0 1 .289-2.405c.199-.36.464-.676.781-.927a2.925 2.925 0 0 1 1.063-.537l.686-.185c.05-.528.045-1.06-.015-1.588l-.519-.128a2.922 2.922 0 0 1-1.093-.533 3.08 3.08 0 0 1-.802-.943 3.264 3.264 0 0 1-.275-2.457l.188-.659a6.368 6.368 0 0 0-1.245-.809l-.485.536c-.278.31-.614.556-.988.724a2.865 2.865 0 0 1-2.362 0 2.985 2.985 0 0 1-.988-.726l-.502-.559c-.434.21-.845.47-1.224.776l.233.87zm2.571 5.878c.28.292.659.457 1.054.457.396 0 .775-.165 1.054-.457a1.6 1.6 0 0 0 .437-1.105 1.6 1.6 0 0 0-.437-1.104 1.457 1.457 0 0 0-1.054-.457c-.395 0-.774.165-1.054.457a1.6 1.6 0 0 0-.436 1.104c0 .415.157.812.436 1.105z",
    fill: "url(#nbptjatdlc)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.463 35.453-.154.513c.313.227.64.43.983.612l.394-.418a4.502 4.502 0 0 1 6.548.003l.422.448c.333-.172.652-.366.957-.582l-.22-.78a4.5 4.5 0 0 1 3.22-5.576l.573-.147c.025-.411.02-.823-.012-1.234l-.349-.082a4.499 4.499 0 0 1-3.276-5.668l.153-.512a8.104 8.104 0 0 0-.984-.612l-.394.417a4.499 4.499 0 0 1-6.548-.003l-.421-.448a8.096 8.096 0 0 0-.956.58l.219.782a4.498 4.498 0 0 1-3.22 5.576l3.065 7.13zm0 0a4.5 4.5 0 0 0-3.276-5.668l-.353-.084a8.903 8.903 0 0 1-.012-1.232l.576-.147 3.065 7.13zm2.77-4.69a2.5 2.5 0 1 0 3.535-3.535 2.5 2.5 0 0 0-3.536 3.535z",
    stroke: "url(#c78oordzed)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "v5tajhurlb",
    x1: 4.073,
    y1: 24.994,
    x2: 36.432,
    y2: 12.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nbptjatdlc",
    x1: 10.422,
    y1: 25.874,
    x2: 34.809,
    y2: 17.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c78oordzed",
    x1: 20.307,
    y1: 30.338,
    x2: 37.373,
    y2: 24.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0nj0mmonia"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightWifiSettingsIcon);
export default __webpack_public_path__ + "static/media/lightWifiSettingsIcon.52dca166d616270e52627326a8fa59ed.svg";
export { ForwardRef as ReactComponent };